import { IAnimatedTitleTrailerFields } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'
import AnimatedTitleTrailer from './AnimatedTitleTrailer'

const ContentfulAnimatedTitleTrailer = withContentful<IAnimatedTitleTrailerFields>(AnimatedTitleTrailer, {
  streamingLogo: (props) => props.fields.streamingLogo?.fields?.file?.url,
  trailerVideo: (props) => props.fields.trailerVideo?.fields?.file?.url,
  trailerVideoFallback: (props) => props.fields.trailerVideoFallback?.fields?.file?.url,
  staticBackground: (props) => props.fields.staticBackground?.fields?.file?.url,
  cloudTileImages: (props) => {
    const cloudTitleImages = props.fields.cloudTileImages
    const cloudTileImagesData: string[] = cloudTitleImages.map((image) => {
      return image.fields.imageAsset?.fields?.file?.url
    })

    return cloudTileImagesData
  },
  cloudMobileTileImages: (props) => {
    const arr = []
    for (let i = 0; i < props.fields.cloudMobileTileImages.length; i++) {
      if (props.fields.cloudMobileTileImages[i].fields.imageAsset) {
        arr.push(props.fields.cloudMobileTileImages[i].fields.imageAsset?.fields?.file?.url)
      }
    }
    return arr
  },
  framedTrailerVideo: (props) => props.fields.framedTrailerVideo?.fields?.file?.url,
  framedTrailerVideoFallback: (props) => props.fields.framedTrailerVideoFallback?.fields?.file?.url,
  framedTrailerStaticBackground: (props) => props.fields.framedTrailerStaticBackground?.fields?.file?.url,
  framedTrailerImageTiles: (props) => {
    const arr = []
    for (let i = 0; i < props.fields.framedTrailerImageTiles.length; i++) {
      arr.push(props.fields.framedTrailerImageTiles[i].fields.imageAsset.fields.file.url)
    }
    return arr
  },
  framedTrailerSmallImageTiles: (props) => {
    const arr = []
    for (let i = 0; i < props.fields.framedTrailerSmallImageTiles.length; i++) {
      arr.push(props.fields.framedTrailerSmallImageTiles[i].fields.imageAsset.fields.file.url)
    }
    return arr
  },
  framedTileText: (props) => props.fields.framedTrailerTileText,
  framedTileGenre: (props) => props.fields.framedTrailerTileGenre,

  mobileImage: (props) => props.fields.mobileDeviceImage?.fields?.file?.url,
  mobileImageWidth: (props) => props.fields.mobileDeviceImage?.fields?.file?.details?.image?.width,
  mobileImageHeight: (props) => props.fields.mobileDeviceImage?.fields?.file?.details?.image?.height,

  lowerImage: (props) => props.fields.tvLowerImage?.fields?.file?.url,
  tvLowerImageWidth: (props) => props.fields.tvLowerImage?.fields?.file?.details?.image?.width,
  tvLowerImageHeight: (props) => props.fields.tvLowerImage?.fields?.file?.details?.image?.height,
  frameImage: (props) => {
    return <BlockRenderer block={props.fields.frameImage} />
  },
  buttonLinkProps: (props) => props.fields.buttonLinkProps?.fields,
})
export default ContentfulAnimatedTitleTrailer
